<template>
	<cardBody class="p-0">
        <div class="card m-0 p-0 border-0 shadow-0" >
            <cardBody class="pb-0 pl-0 pr-0 pt-1">
                <div class="row">
                    <div class="col-md-6">
                        <search v-model="search" placeholder="Type to search" label="Filter"></search>
                    </div>
                    <!--
                    <div class="col-md-3">
                        <select2 v-model="category" :options="flatCategories" label="Category" placeholder="Any" />
                    </div>
                    -->
                    <div class="col-md-3">
                        <select2 v-model="status" :options="statusoptions" placeholder="Any" label="Status" :hideSearchBox="true" :allowClear="false"/>
                    </div>
                    <div class="col-md-3">
                        <daterangepicker v-model="created"  label="Join Date"/>
                    </div>
                </div>
            </cardBody>
            <cardBody class="card-footer d-sm-flex justify-content-sm-between align-items-sm-center bg-light d-flex">
                <div>
                    <div v-if="! loading.status">
                        {{meta.total}} {{ meta.total != 1 ? 'users' : 'user'}}
                        <span v-if="hasAnyFilter">
                            using filters. <a href="javascript:void(0)" @click="clearFilters">Clear filters</a>
                        </span>
                    </div>
                </div>
                <div class="d-flex"><div class="pr-2 mt-1"># per page : </div><select2 v-model="perpage" :options="per_page_options" placeholder="Par page" :hideSearchBox="true" :allowClear="false" class="pb-0 mb-0 ml-auto"/></div>
            </cardBody>
        </div>
	</cardBody>
</template>
<script>

import uiCard from '@components/pages/elements/card'
import ui from '@components/ui'
import advancesearch from '@components/ui/advancesearch/search.vue'

export default {
	components : {
		'cardBody' : uiCard.cardBody,
		'search' : ui.search,
		'select2' : ui.select2,
        'daterangepicker' : ui.daterangepicker,
        advancesearch
 	},
    props: {
    	misc : {
        	type: [Object, Array],
            required : false
        },
    	filters : {
        	type: Object,
            required : true
        },
        options : {
        	type: Object,
            required : true
        },
        meta : {
            type: Object,
            required : true
        },
        loading : {
            type: Object,
            default : {
                status : false
            }
        }
    },
    watch: {
        value(v){
            this.search = v
        }
    },
    data() {
		return {
		}
	},
    created() {
        let filters =  this.$store.getters['users/filters'];
        if (filters) {
            //this.filters.category = this.$route.query.category ? this.$route.query.category : filters.category;
            //this.filters.collection = this.$route.query.collection ? this.$route.query.collection : filters.collection;
            this.filters.status = filters.status;
            this.filters.search = filters.search;
            this.filters.created = filters.created;
        }
        else {
            //Call manually filters update to trigger the page data load
            this.clearFilters();
        }
    },
	mounted () {

    },
    computed: {
        hasAnyFilter : function (){
            return this.filters.search || this.filters.status || this.filters.created.from || this.filters.created.to; // || this.filters.category || this.filters.collection
        },
        store : function(){
    		return this.$store.getters
    	},
    	per_page_options : function(){
    		return this.$store.getters['page/per_page_options'];
    	},
    	statusoptions : function(){
    		return [
    			{ id : -1, name : "Any"},
                { id : 1, name : "Active"},
                { id : 0, name : "Inactive"}
    		];
    	},
    	search : {
    		get : function(){
    			return this.filters.search
    		},
    		set : function (value){
    			this.filters.search = value;
    			this.filterschanged(true)
    		}
    	},
    	status : {
            get : function(){
                return this.filters.status == '' ? -1 : this.filters.status
            },
            set : function (value){
                value = value == -1 ? '' : value;
                this.filters.status = value;
                this.filterschanged(true);
            }
        },
        created : {
            get : function(){
                return this.filters.created
            },
            set : function (value){
                this.filters.created = value;
                this.filterschanged(true)
            }
        },
    	perpage : {
    		get : function(){
    			return this.$store.getters['page/per_page'];
    		},
    		set : function (value){
    			this.$store.dispatch('page/per_page', value);
    			this.options.per_page = value;
    			this.optionschanged()
    		}
    	},

        /*
    	category : {
    		get : function(){
    			return this.filters.category == '' ? -1 : this.filters.category
    		},
    		set : function (value){
                value = value == -1 ? '' : value;
    			this.filters.category = value;
    			this.filterschanged(true)
    		}
    	},
        collection : {
            get : function(){
                return this.filters.collection == '' ? -1 : this.filters.collection
            },
            set : function (value){
                value = value == -1 ? '' : value;
                this.filters.collection = value;
                this.filterschanged(true)
            }
        },
         */
    },
    methods : {
    	filterschanged : function(resetPage = false){
            this.$store.dispatch('users/setFilters', this.filters);
            if (resetPage) {
                this.$emit('filters:resetPage');
            }
    		this.$emit('filters:changed', this.filters);
    	},
        setParent : function(parrentId){
            this.filters.parent = parrentId
        },
    	optionschanged : function(){
    		this.$emit('options:changed', this.options)
    	},
        clearFilters : function () {
            this.$emit('filters:changed', {
                //category: this.$route.query.category ? this.$route.query.category : '',
                //collection: this.$route.query.collection ? this.$route.query.collection : '',
                search:'',
                status:''
            })
        }
    }
};
</script>